import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

export default function BasicPopover({ title, content, color = 'blue' }: { title: string, content: string, color?: string }) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <span aria-describedby={id} style={{ color, borderBottom: `1px dashed ${color}`, cursor: 'pointer' }} onClick={handleClick}>
        {title}
      </span>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Typography sx={{ p: 2, width: 300, whiteSpace: 'pre-wrap', fontSize: 'clamp(0.5rem, 3vw, 0.9rem) !important' }}>{content}</Typography>
      </Popover>
    </div>
  );
}
